import { mixins, styled } from '@bob/library'

export const ExplainerCard = styled.div`
  background: ${mixins.colors.backgroundPrimary};
  border: 1px solid ${mixins.colors.grayLowlight};
  ${mixins.padding(25)};
  width: 100%;
  border-radius: 10px;
`

export const Caption = styled.h5`
  width: 100%;
  ${mixins.typography.subtitleMedium};
  ${mixins.margin(0)};
`
export const Headline = styled.h1`
  width: 100%;
  ${mixins.typography.headlineXl};
  ${mixins.margin.top(20)};
  ${mixins.margin.bottom(40)};
  ${mixins.media.max.phone} {
    ${mixins.typography.headlineLarge};
  }
`

export const Heading = styled.h3`
  ${mixins.typography.headlineSmall}
  ${mixins.margin(20, 0, 10)}
`

export const Text = styled.div`
  ${mixins.margin.bottom(20)}
  p {
    ${mixins.typography.paragraphMedium}
  }
`
export const LearnMoreButtonWrapper = styled.div`
  ${mixins.margin(30)}
`

export const Stacked = styled.div`
  display: flex;
  gap: 20px;
  flex-direction: row;
  flex-wrap: wrap;

  ${ExplainerCard} {
    flex: 1 1 300px;
  }
`
